import { isEmbeddedConfluence_DO_NOT_USE } from '@atlassian/embedded-confluence/isEmbeddedConfluence';

import { fg } from '@confluence/feature-gating';

import { useEmbeddedViewPageFeatures } from './useEmbeddedViewPageFeatures';

export const useEmbeddedModernHeader = () => {
	const isEmbeddedConfluence = isEmbeddedConfluence_DO_NOT_USE();
	const { hasModernHeader } = useEmbeddedViewPageFeatures();

	return isEmbeddedConfluence && hasModernHeader && fg('confluence-mr2-native-allowed-features');
};
